<template>
  <div id="facilityBuddy">
    <Loader v-if="isFacilityLoading" />
    <v-card v-else>
      <v-toolbar elevation="0">
        <v-btn icon @click="routeToFaciltiiesList">
          <v-icon size="40">mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Facility</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="primary" :loading="saving" @click="updateFacility">
          Save Changes
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>
      <v-container fluid grid-list-lg>
        <v-layout wrap>
          <v-flex lg6 md6 xs12>
            <v-card
              elevation="12"
              min-height="420"
            >
              <v-img
                :src="facilityStaffHubLogoUrl"
                min-height="250"
                height="280"
              ></v-img>
              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="Facility Name"
                  v-model="selectedFacility.name"
                ></v-text-field>
              </v-card-title>

              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="MCare Care API Key"
                  v-model="selectedFacility.careApiKey"
                ></v-text-field>
              </v-card-title>

              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="MCare Generic API Dev Key"
                  v-model="mCareGenericAPIData.devApiKey"
                ></v-text-field>
              </v-card-title>

              <v-divider class="mx-4 my-2"></v-divider>

              <v-card-title>InsertCareNote API</v-card-title>
              <p class="pl-6 text-gray">Enable the InsertCareNote API proxy. External systems can insert care notes via ResHub using the MCare Generic API credentials.</p>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Enable InsertCareNote API"
                  v-model="insertCareNoteAPIData.isEnabled"
                  @change="onInsertCareNoteEnabledChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title v-if="insertCareNoteAPIData.isEnabled && insertCareNoteAPIData.resHubApiKey">
                <v-text-field
                  class="pa-2"
                  label="ResHub API Key"
                  v-model="insertCareNoteAPIData.resHubApiKey"
                  hint="External systems will use this key as Bearer token to authenticate with ResHub"
                  persistent-hint
                  readonly
                  append-icon="mdi-content-copy"
                  @click:append="copyApiKeyToClipboard"
                ></v-text-field>
              </v-card-title>

              <v-card-title v-if="insertCareNoteAPIData.isEnabled && insertCareNoteAPIData.resHubApiKey">
                <v-text-field
                  class="pa-2"
                  label="API Documentation URL"
                  :value="insertCareNoteApiDocsUrl"
                  hint="Swagger documentation for the InsertCareNote API"
                  persistent-hint
                  readonly
                  append-icon="mdi-content-copy"
                  @click:append="copyDocsUrlToClipboard"
                ></v-text-field>
              </v-card-title>

              <v-card-title v-if="insertCareNoteAPIData.isEnabled && insertCareNoteAPIData.resHubApiKey">
                <v-text-field
                  class="pa-2"
                  label="InsertCareNote Endpoint URL"
                  :value="insertCareNoteEndpointUrl"
                  hint="POST to this URL to insert care notes"
                  persistent-hint
                  readonly
                  append-icon="mdi-content-copy"
                  @click:append="copyEndpointUrlToClipboard"
                ></v-text-field>
              </v-card-title>

              <v-divider class="mx-4 my-2"></v-divider>

              <v-card-title v-if="facility?.dateTimeCreated">
                <v-text-field readonly 
                :value="(selectedFacility.dateTimeCreated.seconds * 1000)| localizedDate(selectedFacility.dateFormat)"
                class="pa-2" label="Creation date">
                </v-text-field> 
              </v-card-title>

              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="FamilyHub App name"
                  readonly
                  v-model="selectedFacility.familyHubAppName"
                ></v-text-field>
              </v-card-title>

              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="Link to FamilyHub for Android"
                  readonly
                  v-model="selectedFacility.linkToFamilyHubForAndroid"
                ></v-text-field>
              </v-card-title>

              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="Link to FamilyHub for iOS"
                  readonly
                  v-model="selectedFacility.linkToFamilyHubForIos"
                ></v-text-field>
              </v-card-title>
           
              <v-card-title>
                <v-text-field
                  class="pa-2"
                  label="Facility Ref Id"
                  v-model="selectedFacility.refId"
                ></v-text-field> 
              </v-card-title>  
              <p class="pl-6">The Facility Ref ID is used for integrations such as with MCare, where the location PCS CID should be entered.  </p>           
              
              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Active Licence"
                  v-model="selectedFacility.isLicenced"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>Modules</v-card-title>
              <p class="pl-6">By enabling Modules below, it will select the checkboxes on the right which turn on and off the relevant features for that module. </p>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Family Engagement Core"
                  v-model="familyEngagementCoreModule"
                  @change="onFamilyEngagementCoreModuleChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Family Engagement Plus (Lifestyle & Concierge)"
                  v-model="familyEngagementPlusModule"
                  @change="onFamilyEngagementPlusModuleChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title v-if="!isAustraliaResHub">
                <v-checkbox
                  class="pa-2"
                  label="Maintenance Core"
                  v-model="maintenanceModule"
                  @change="onMaintenanceModuleChange"
                ></v-checkbox>
              </v-card-title>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Digital Signage"
                  v-model="digitalSignageModule"
                  @change="onDigitalSignageModuleChange"
                ></v-checkbox>
              </v-card-title>





<!--              <v-card-title>Modules </v-card-title>
              <p class="pl-6">By enabling Modules below, it will select the checkboxes on the right which turn on and off the relevant features for that module. </p>

              <v-card-title>
                <v-checkbox
                  class="pa-2"
                  label="Other"
                  v-model="otherModule"
                  @change="onOtherModuleChange"
                ></v-checkbox>
              </v-card-title>-->

            </v-card>
          </v-flex>

          <v-flex v-if="selectedFacility.skin === 'default'" lg6 md6 xs12>
            <v-card elevation="12" min-height="700">
              <v-list flat subheader three-line>
                <v-subheader>{{ $t('Settings.FacilitySettings.DefaultSkinFeatures') }}</v-subheader>

                <v-list-item-group
                  v-model="settings"
                  active-class=""
                  multiple
                  class="facility-settings"
                >
                  <NonMCareBundleNew
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled" />

                  <MCareIntegrationContactsProfilesNew
                    :facility="selectedFacility"
                    :settings="settings"
                    :isAnyStaffAssignedToFacility="isAnyStaffAssignedToFacility"
                    :arecheckedesdisabled="arecheckedesdisabled" />

                  <MCareIntegrationDailyCareNew
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    ref="mCareIntegrationDailyCareNew"
                  />

                  <FamilyEngagementCoreNew
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    @send-bundle-value="onFamilyEngagementCoreBundleChange"
                    ref="familyEngagementCoreBundleRef" />

                  <FamilyEngagementPlusNew
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    :facilityCopy="facilityCopy"
                    @send-bundle-value="onFamilyEngagementPlusBundleChange"
                    ref="familyEngagementPlusBundleRef" />

                  <MaintenanceNew
                    v-if="!isAustraliaResHub"
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    @send-bundle-value="onMaintenanceBundleChange"
                    ref="maintenanceBundleRef" />

                  <DigitalSignageBundleNew
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled"
                    @send-bundle-value="onDigitalSignageBundleChange"
                    ref="digitalSignageBundleRef"/>

                  <OtherNew
                    :facility="selectedFacility"
                    :settings="settings"
                    :arecheckedesdisabled="arecheckedesdisabled" />

                </v-list-item-group>
              </v-list>
            </v-card>
          </v-flex>

          <v-flex
            lg12
            md12
            xs12
          >
            <v-card
              elevation="12"
              min-height="500"
            >
              <v-card-title
                >Facility Staff Users
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('GeneralTranslations.Search')"
                  single-line
                  hide-details
                ></v-text-field>

                <v-btn
                  class="primary mr-5 ml-5"
                  @click="openManageRolesDialog"
                >
                  {{ $t('Settings.StaffUsersList.ManageRoles') }}
                </v-btn>

                <v-btn
                  class="primary mr-5"
                  @click="openUserAddRoleDialog"
                >
                Add New Role
              </v-btn>
                <v-dialog
                  v-model="dialog"
                  max-width="600px"
                  persistent
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="primary"
                      v-bind="attrs"
                      v-on="on"
                      >{{ $t('Settings.StaffUsersList.AddUser') }}</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{
                        $t('Settings.StaffUsersList.CreateUser')
                      }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container class="p-0">
                        <validation-observer
                          ref="observer"
                          v-slot="{ invalid }"
                        >
                          <v-form
                            ref="createUserForm"
                            lazy-validation
                            id="create-user-form"
                            @submit.prevent="submit"
                          >
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Name"
                                rules="required"
                              >
                                <v-text-field
                                  v-model="form.name"
                                  :label="
                                    $t('Settings.StaffUsersList.Name') + '*'
                                  "
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Email"
                                rules="required|email"
                              >
                                <v-text-field
                                  v-model="form.email"
                                  :label="
                                    $t('Settings.StaffUsersList.EmailAddress') +
                                    '*'
                                  "
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="FacilityAccess"
                                rules="required"
                              >
                                <v-select
                                  v-model="form.facilities"
                                  :items="facilitiesForOrg"
                                  :error-messages="errors"
                                  item-text="name"
                                  :label="
                                    $t(
                                      'Settings.StaffUsersList.FacilityAccess'
                                    ) + '*'
                                  "
                                  multiple
                                  required
                                  return-object
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="AccessLevel"
                                rules="required"
                              >
                                <v-select
                                  v-model="form.accessLevel"
                                  :items="staffAccessLevels"
                                  item-text="text" item-value="value" 
                                  :error-messages="errors"
                                  :label="
                                    $t('Settings.StaffUsersList.AccessLevel') +
                                    '*'
                                  "
                                  required
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Role"
                                rules=""
                              >
                                <v-select
                                  class="autofocus"
                                  v-model="form.role"
                                  :items="usersRoles"
                                  item-text="name"
                                  :label="$t('Settings.StaffUsersList.Role')"
                                  :error-messages="errors"
                                  required
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="!isStaffUserInviteEmailTemplateExists"
                            >
                              <v-alert
                                dense
                                outlined
                                color="error"
                              >
                                <v-row align="center">
                                  <v-col
                                    cols="8"
                                    class="text-subtitle-2"
                                  >
                                    {{
                                      $t(
                                        'Settings.StaffUsersList.EmailTemplateWithType'
                                      )
                                    }}
                                    {{
                                      $t(
                                        'Settings.StaffUsersList.MissingStaffUserInviteText'
                                      ) 
                                    }}
                                  </v-col>
                                  <v-col>
                                    <router-link
                                      @click.native="dialog = false"
                                      class="text-decoration-none"
                                      to="/settings?tab=emailTemplates"
                                      ><v-btn
                                        color="primary"
                                        block
                                      >
                                        {{
                                          $t('GeneralTranslations.Create')
                                        }}</v-btn
                                      ></router-link
                                    >
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-col>

                            <v-col cols="12">
                              <small>{{
                                $t(
                                  'GeneralTranslations.StarIndicatesRequiredField'
                                )
                              }}</small>
                            </v-col>

                            <v-col cols="12">
                              <div class="d-flex">
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="error"
                                  text
                                  class="mr-4"
                                  @click="cancel"
                                  >{{ $t('GeneralTranslations.Cancel') }}</v-btn
                                >
                                <v-btn
                                  color="primary"
                                  :disabled="
                                    invalid ||
                                    submited ||
                                    !isStaffUserInviteEmailTemplateExists
                                  "
                                  :loading="submited"
                                  type="submit"
                                >
                                  {{ $t('Settings.StaffUsersList.CreateUser') }}
                                </v-btn>
                              </div>
                            </v-col>
                          </v-form>
                        </validation-observer>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>

              <v-btn class="primary ml-5" @click="openUserInvitesDialog">
                Send User Invites
                </v-btn>
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="facilityUsers"
                :loading="isFacilityUsersLoading"
                :search="search"
                @click:row="handleClickUser"
                class="pr-8"
              >
                <template v-slot:item.profilePicUrl="{ item }">
                  <v-avatar size="50px" class="mt-3 mb-3">
                    <img :src="item.profilePicUrl" alt />
                  </v-avatar>
                </template>

                <template v-slot:item.facilities="{ item }">
                  <v-autocomplete
                      class="fixed-width mt-1"
                      hide-details
                      v-model="item.facilitiesIds"
                      :search-input.sync="item._search"
                      @change="onUserFacilityChanged($event, item)"
                      :items="facilitiesForOrg"
                      item-text="name"
                      item-value="id"
                      multiple
                      :disabled="item.refOrigin === 'rci' && item.fileClosed === true"
                    ></v-autocomplete>
                </template>

                <template v-slot:item.mCareStatus="{ item }">
                  <v-chip
                    v-if="item.mCareStatus && selectedFacility.careApiKey"
                    :color="item.mCareStatus === 'Open' ? 'success' : 'error'"
                    text-color="white"
                    small
                  >
                    {{ item.mCareStatus }}
                  </v-chip>
                </template>

                <template v-slot:item.isEnabledImpersonation="{ item }">
                  <v-btn class="primary mr-4" v-if="item?.isEnabledImpersonation" :loading="loadingUsers.includes(item.id)" @click="loginAsStaffUser(item)">{{$t('Impersonation.Impersonate')}}</v-btn>
                  <v-btn class="primary" @click="openResetPasswordDialog(item)"> {{ $t('Settings.UserProfile.ResetPassword') }}</v-btn>
                </template>

              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <FacilityUsersRolesDialog ref="facilityUsersRolesDialog" />

      <FacilityUserAddRoleDialog ref="facilityUserAddRoleDialog" />

      <InviteUsersDialog ref="inviteUsersDialogRef"/>

      <v-divider></v-divider>
    </v-card>
    <ResetUserPasswordEmailDialog ref="resetUserPasswordEmailDialog" :user="user" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import 'firebase/firestore';
import * as firebase from 'firebase/app';
import { StaffAccessLevels } from '@/enums/StaffAccessLevels';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { DEFAULT_AVATAR_BLACK } from '@/consts/default-avatar';
import { getRegionName } from '@/utils/functionsRegion';
import FacilityUsersRolesDialog from '@/views/settings/facility/facility-users-roles-dialog/FacilityUsersRolesDialog.vue';
import FacilityUserAddRoleDialog from '@/views/settings/facility/facility-users-add-role-dialog/FacilityUserAddRoleDialog.vue';
import { DefaultEmailTemplateType } from '@/enums/DefaultEmailTemplateType';
import { getEnabledRoute } from "@/router/router-helper";
import Loader from '@/components/loader/Loader.vue';
import ResetUserPasswordEmailDialog from "@/views/settings/userProfile/ResetUserPasswordEmailDialog.vue";
import InviteUsersDialog from "@/views/settings/facility/users-invitation/InviteUsersDialog.vue";
import {DEFAULT_NO_IMAGE} from "@/consts/default-no-image";
import { getStaffAccessLevels } from "@/utils/accessControl/getAccessLevelDisplayName";
import { UserTypeEnum } from "@/enums/UserTypeEnum";
import { AuditLogsTier1 as Tier1 } from '@/enums/AuditLogs';
import { facilitySettingsAuditLogs } from '@/consts/auditLogs';
import MaintenanceNew from '@/buddy/facilities/bundles-new/maintenance/Maintenance.vue';
import DigitalSignageBundleNew from '@/buddy/facilities/bundles-new/digitalSignage/DigitalSignageBundle.vue';
import FamilyEngagementCoreNew from '@/buddy/facilities/bundles-new/familyEngagementCore/FamilyEngagementCore.vue';
import FamilyEngagementPlusNew from '@/buddy/facilities/bundles-new/familyEngagementPlus/FamilyEngagementPlus.vue';
import MCareIntegrationDailyCareNew from '@/buddy/facilities/bundles-new/mCareIntegrationDailyCare/mCareIntegrationDailyCare.vue';
import MCareIntegrationContactsProfilesNew
  from "@/buddy/facilities/bundles-new/mCareIntegrationContactsProfiles/mCareIntegrationContactsProfiles.vue";
import NonMCareBundleNew from '@/buddy/facilities/bundles-new/nonMCareCustomers/nonMCareCustomers.vue';
import OtherNew from '@/buddy/facilities/bundles-new/other/Other.vue';
import { isAustraliaResHub } from '@/utils/projectConfig';

export default {
  name: 'BuddyFacility',
  computed: {
    ...mapState({
      facilitiesForOrg: state => state.userModule.facilitiesForOrg,
      facilityUsers: state => state.facilityModule.selectedFacilityUsers,
      emailTemplates: state => state.facilityModule.facilityEmailTemplates,
      currentUser: state => state.authModule.user,
      isStaffUserInviteEmailTemplateExists() {
        return (
          this.emailTemplates.filter(
            emailTemplate =>
              emailTemplate.type === DefaultEmailTemplateType.StaffUserInvite
          ).length > 0
        );
      },
      usersRoles() {
        return this.$store.state.userModule.usersRoles;
      },
    }),

    staffAccessLevels() {
      const hasMaintenanceFeature = true;
      return getStaffAccessLevels(this.selectedFacility?.isEnabledStaffAPI, hasMaintenanceFeature);
    },

    isAnyStaffAssignedToFacility(){
      return this.$store.state.facilityModule.selectedFacilityUsers.some(x=>x.accessLevel === StaffAccessLevels.OrgAdmin)
    },

    isAustraliaResHub() {
      return isAustraliaResHub();
    },

    insertCareNoteApiDocsUrl() {
      return 'https://europe-west1-reshub-test.cloudfunctions.net/insertCareNote/';
    },

    insertCareNoteEndpointUrl() {
      const facilityId = this.$route.params.id;
      return `https://europe-west1-reshub-test.cloudfunctions.net/insertCareNote/facility/${facilityId}/InsertCareNote`;
    }
  },
  components: {
    OtherNew,
    MaintenanceNew,
    NonMCareBundleNew,
    DigitalSignageBundleNew,
    FamilyEngagementCoreNew,
    FamilyEngagementPlusNew,
    MCareIntegrationDailyCareNew,
    MCareIntegrationContactsProfilesNew,
    InviteUsersDialog,
    Loader,
    ValidationObserver,
    ValidationProvider,
    FacilityUsersRolesDialog,
    FacilityUserAddRoleDialog,
    ResetUserPasswordEmailDialog
  },
  data() {
    return {
      facility: null,
      isFacilityLoading: true,
      isFacilityUsersLoading: false,
      isFacilityNameChanged: false,
      selectedFacility: null,
      currentDate: new Date().getDate(),
      search: '',
      accessLevelsEnum: StaffAccessLevels,
      dialog: false,
      arecheckedesdisabled: false,
      saving: false,
      facilityCopy: null,
      facilityStaffHubLogoUrl: DEFAULT_NO_IMAGE,
      headers: [
        {
          text: '',
          align: '',
          sortable: false,
          width: 70,
          value: 'profilePicUrl',
        },
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          width: "300",
          value: 'name',
        },
        {
          text: 'Access Level',
          align: 'start',
          sortable: false,
          width: "300",
          value: 'accessLevel',
        },
        {
          text: 'Email',
          align: 'start',
          sortable: false,
          width: "300",
          value: 'email',
        },
        {
          text: 'Facility Access',
          align: 'start',
          sortable: false,
          width: "280",
          value: 'facilities',
        },
        {
          text: 'mCare Status',
          align: 'start',
          sortable: false,
          width: "150",
          value: 'mCareStatus',
        },
        {
          text: '',
          align: 'end',
          sortable: false,
          width: "380",
          value: 'isEnabledImpersonation',
        }
      ],
      form: {
        name: '',
        email: '',
        facilities: [],
        accessLevel: '',
        role: '',
      },
      loadingUsers: [],
      familyFeaturesChanged: {
        isCareSummaryChanged: false,
        isCarePlanChanged: false,
        isDailyCareChanged: false,
        isDailyPlanChanged: false
      },
      digitalSignageModule: false,
      familyEngagementCoreModule: false,
      familyEngagementPlusModule: false,
      maintenanceModule: false,
      otherModule: false,
      mCareGenericAPIData: { apiKey: null, devApiKey: null },
      insertCareNoteAPIData: { isEnabled: false, resHubApiKey: '' },
      initialCheckboxes: null,
      logs: null
    };
  },
  async created() {
    this.selectedFacility = await this.$store.dispatch("getBuddyFacility", this.$route.params.id);
    this.initialCheckboxes = JSON.parse(JSON.stringify(this.selectedFacility));
    await this.$store.dispatch("getFacilitiesForOrg", this.selectedFacility.orgId);

    this.facilityStaffHubLogoUrl = this.selectedFacility?.staffHubLogoUrl || DEFAULT_NO_IMAGE
    this.selectedFacility.familyHubAppName = this.selectedFacility?.familyHubAppName || ""
    this.selectedFacility.linkToFamilyHubForAndroid = this.selectedFacility?.linkToFamilyHubForAndroid || ""
    this.selectedFacility.linkToFamilyHubForIos = this.selectedFacility?.linkToFamilyHubForIos || ""

    this.isFacilityLoading = false;
    this.facilityCopy = JSON.parse(JSON.stringify(this.selectedFacility));

    this.isFacilityUsersLoading = true;
    await this.$store.dispatch('getOrgUsers', this.selectedFacility.orgId);
    this.isFacilityUsersLoading = false;

    if(this.$route.params.id) {
      const mCareGenericAPIData = await this.$store.dispatch('getMCareGenericAPIData', this.$route.params.id);
      if(mCareGenericAPIData){
        this.mCareGenericAPIData = mCareGenericAPIData
      }

      const insertCareNoteAPIData = await this.$store.dispatch('getInsertCareNoteAPIData', this.$route.params.id);
      if(insertCareNoteAPIData){
        this.insertCareNoteAPIData = insertCareNoteAPIData
      }
    }
  },
  methods: {
    openResetPasswordDialog(user){
      if (this.$refs.resetUserPasswordEmailDialog) this.$refs.resetUserPasswordEmailDialog.open(user)
    },
    routeToFaciltiiesList() {
      setTimeout(() => this.$router.push('/buddy/facilities'), 2000);
    },
    async updateFacility() {
      this.saving = true;
      this.selectedFacility.modules.digitalSignage.isEnabled = this.digitalSignageModule;
      this.selectedFacility.modules.familyEngagementCore.isEnabled = this.familyEngagementCoreModule;
      this.selectedFacility.modules.familyEngagementPlus.isEnabled = this.familyEngagementPlusModule;
      this.selectedFacility.modules.maintenance.isEnabled = this.maintenanceModule;

      this.selectedFacility.modules.familyEngagementCore.categories.communicationManagement = this.$refs.familyEngagementCoreBundleRef.communicationCategory;
      this.selectedFacility.modules.familyEngagementCore.categories.dailyCare = this.$refs.mCareIntegrationDailyCareNew.dailyCareCategory;

      this.selectedFacility.updatedById = this.currentUser.id;
      this.selectedFacility.updatedByType = UserTypeEnum.Staff;
      this.selectedFacility.typesOfRecordChanged = await this.getAuditLogs();
      this.selectedFacility.initiatorAccessLevel = this.currentUser.accessLevel
      this.selectedFacility.initiatorName = this.currentUser.name

      try {
        await this.$store.dispatch('updateBuddyFacility', JSON.parse(JSON.stringify(this.selectedFacility)))
        if(this.isFacilityNameChanged) {
          await this.$store.dispatch("updateFacilityStaffMailingList", {
            facilityId: this.selectedFacility.id,
            facilityName: this.selectedFacility.name,
            updatedById: this.currentUser.id,
            updatedByType: UserTypeEnum.Staff,
            typesOfRecordChanged: await this.getAuditLogs(),
            initiatorAccessLevel: this.currentUser.accessLevel,
            initiatorName: this.currentUser.name
          });
        }

        if(typeof this.mCareGenericAPIData.apiKey !== 'undefined' && typeof this.mCareGenericAPIData.devApiKey !== 'undefined'){
            const data = {
            id: this.mCareGenericAPIData.id,
            facilityId: this.$route.params.id,
            updates:{
                apiKey: this.mCareGenericAPIData.apiKey,
                devApiKey: this.mCareGenericAPIData.devApiKey,
            }
          }

          this.mCareGenericAPIData = await this.$store.dispatch('updateMCareGenericAPIData', data)
        }

        // Save InsertCareNote API data
        console.log('facility.vue - insertCareNoteAPIData before save:', JSON.stringify(this.insertCareNoteAPIData, null, 2));
        const insertCareNoteData = {
          id: this.insertCareNoteAPIData.id,
          facilityId: this.$route.params.id,
          updates: {
            isEnabled: this.insertCareNoteAPIData.isEnabled,
            resHubApiKey: this.insertCareNoteAPIData.resHubApiKey,
          }
        }
        console.log('facility.vue - sending to store:', JSON.stringify(insertCareNoteData, null, 2));
        this.insertCareNoteAPIData = await this.$store.dispatch('updateInsertCareNoteAPIData', insertCareNoteData)
        console.log('facility.vue - after save:', JSON.stringify(this.insertCareNoteAPIData, null, 2));

        this.facilityCopy = JSON.parse(JSON.stringify(this.selectedFacility))
      } catch (error) {
        console.error(error);
      }
      finally {
        this.selectedFacility = await this.$store.dispatch("getBuddyFacility", this.$route.params.id);
        this.initialCheckboxes = JSON.parse(JSON.stringify(this.selectedFacility));
        this.saving = false;
      }
    },
    onUserFacilityChanged(facilitiesIds, item) {
      // If user is closed in mCare, prevent facility selection
      if (item.refOrigin === 'rci' && item.fileClosed === true) {
        item.facilitiesIds = [];
        item.facilities = [];
        this.$toast.warning('Cannot assign facilities to closed mCare users');
        return;
      }
      
      item._search = ''
      facilitiesIds = Array.isArray(facilitiesIds) ? [...new Set(facilitiesIds)] : []
      const selected = new Set(facilitiesIds);
      const updates = {
        id: item.id,
        facilitiesIds,
        facilities: this.facilitiesForOrg.filter(f => selected.has(f.id))
          .map(x => ({ id: x.id, name: x.name })).filter((f, i, arr) => arr.findIndex(z => z.id === f.id) === i)
      }

      item.facilitiesIds = updates.facilitiesIds
      item.facilitiesIds = updates.facilities

      this.$store.dispatch("updateUser", updates);
    },
    async loginAsStaffUser(row) {
      this.loadingUsers.push(row.id);

      const superUserId = this.$store.state.authModule.user.id

      return await firebase.app()
          .functions(getRegionName())
          .httpsCallable('impersonation-getToken')({
            superUserId: superUserId,
            staffUserId: row.id,
            facilityId: row.facilityId
          }).then(async (impersonationTokenResult) => {

            if (impersonationTokenResult.data?.status === 400) {
              this.$toast.open({
                message: impersonationTokenResult.data?.error,
                type: "error"
              });

              return;
            }

            const impersonationCustomToken = impersonationTokenResult.data.token

            //store superUserId and other data to be able to stop impersonation and sign in as super user
            await this.$store.dispatch("setImpersonation", { superUserId: superUserId, selectedBuddyFacilityId: this.selectedFacility.id })

            //get custom token and sign in as impersonated user
            await this.$store.dispatch("signInByCustomToken", {  customToken: impersonationCustomToken })

            //get enabled route for impersonated user (premium features)
            const enabledRoute = getEnabledRoute(this.$store.getters?.premiumFeatures)

            //redirect to enabled route
            this.$router.push(enabledRoute.path);
         
          }).catch(error => {
              this.$toast.open({
                message: error.message,
                type: "error"
              });
          }).finally(() => {
            this.loadingUsers = this.loadingUsers.filter(x => x !== row.id);
          })
    },
    async submit() {
      if (this.submited == true) return true;

      this.submited = true;

      const isValidEmail = await this.validateEmail(this.form.email);

      if (!isValidEmail) {
        this.$refs.observer.setErrors({
          Email: [
            this.$i18n.messages[this.$i18n.locale][
              'GeneralTranslations.EmailAlreadyExists'
            ],
          ],
        });

        this.submited = false;

        return;
      }

      const facilities = this.form.facilities.map(facility => ({
        id: facility.id,
        name: facility.name,
      }));

      const facilitiesIds = this.form.facilities.map(facility => facility.id);
      const facility = this.form.facilities[0];

      const user = {
        ...this.form,
        facilityId: facility.id,
        regionId: facility.regionId,
        orgId: facility.orgId,
        facilities,
        facilitiesIds,
        profilePicUrl: DEFAULT_AVATAR_BLACK,
        createdById: this.currentUser.id,
        createdByType: UserTypeEnum.Staff,
        initiatorAccessLevel: this.currentUser.accessLevel,
        initiatorName: this.currentUser.name,
        typesOfRecordChanged: await this.getAuditLogs(),
      };

      if (this.form.role) {
        const roleId = this.usersRoles.find(x => x.name === this.form.role).id;
        user.roleId = roleId;
      } else {
        delete user.role;
      }

      await this.$store
        .dispatch('createNewFacilityUser', {
          user,
          orgId: facility.orgId,
        })
        .finally(() => {
          this.submited = false;
          this.resetForm();
        });

      this.dialog = false;
    },
    resetForm() {
      this.form.name = '';
      this.form.email = '';
      this.form.facilities = [];
      this.form.accessLevel = '';
      this.form.role = '';
      this.$refs.createUserForm.reset();
      this.$refs.observer.reset();
    },
    cancel() {
      this.dialog = false;
      this.resetForm();
    },
    async validateEmail(email) {
      const result = await firebase
        .app()
        .functions(getRegionName())
        .httpsCallable('checkIfEmailExists')({
        emailAddress: email,
        orgId: this.selectedFacility.orgId,
      });

      if (result.data.data.number > 0) {
        return false;
      }

      return true;
    },
    openManageRolesDialog() {
      this.$refs.facilityUsersRolesDialog.open();
    },
    openUserAddRoleDialog() {
      this.$refs.facilityUserAddRoleDialog.open();
    },
    openUserInvitesDialog(){
      this.$refs.inviteUsersDialogRef.open(this.selectedFacility.id, this.selectedFacility.orgId);
    },

    // NEW METHODS
    onDigitalSignageBundleChange(value) {
      this.digitalSignageModule = value;
    },
    onDigitalSignageModuleChange(value) {
      this.$refs.digitalSignageBundleRef.digitalSignageBundleUpdate(value);
    },

    onMaintenanceBundleChange(value) {
      this.maintenanceModule = value;
    },
    onMaintenanceModuleChange(value) {
      this.$refs.maintenanceBundleRef.maintenanceBundleUpdate(value)
    },

    onFamilyEngagementCoreBundleChange(value) {
      this.familyEngagementCoreModule = value;
    },
    onFamilyEngagementCoreModuleChange(value) {
      this.$refs.familyEngagementCoreBundleRef.familyEngagementCoreBundleUpdate(value);
    },

    onFamilyEngagementPlusBundleChange(value) {
      this.familyEngagementPlusModule = value;
    },
    onFamilyEngagementPlusModuleChange(value) {
      this.$refs.familyEngagementPlusBundleRef.familyEngagementPlusBundleUpdate(value);
    },



    onOtherBundleChange(value) {
      this.otherModule = value;
    },

    // Send modules changes to child components
    onResHubPlusModuleChange(value) {
      this.$refs.resHubPlusBundleRef.resHubPlusBundleUpdate(value);
    },
    onOtherModuleChange(value) {
      this.$refs.otherBundleRef.otherBundleUpdate(value);
    },
    onInsertCareNoteEnabledChange(value) {
      if (value && !this.insertCareNoteAPIData.resHubApiKey) {
        // Auto-generate API key when enabling
        this.insertCareNoteAPIData.resHubApiKey = this.generateApiKey();
      }
    },
    generateApiKey() {
      // Generate a secure random API key
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const array = new Uint8Array(32);
      crypto.getRandomValues(array);
      for (let i = 0; i < 32; i++) {
        result += chars[array[i] % chars.length];
      }
      return result;
    },
    copyApiKeyToClipboard() {
      navigator.clipboard.writeText(this.insertCareNoteAPIData.resHubApiKey);
      this.$toast.open({ message: 'API Key copied to clipboard', type: 'success' });
    },
    copyDocsUrlToClipboard() {
      navigator.clipboard.writeText(this.insertCareNoteApiDocsUrl);
      this.$toast.open({ message: 'Documentation URL copied to clipboard', type: 'success' });
    },
    copyEndpointUrlToClipboard() {
      navigator.clipboard.writeText(this.insertCareNoteEndpointUrl);
      this.$toast.open({ message: 'Endpoint URL copied to clipboard', type: 'success' });
    },
    async getAuditLogs() {
      this.logs = JSON.parse(JSON.stringify(facilitySettingsAuditLogs));
      const facilityKeys = Object.keys(this.selectedFacility);

      for (const key of facilityKeys) {
        if (this.selectedFacility[key] !== this.initialCheckboxes[key]) {
          this.logs.forEach(log => {
            log.options.forEach(option => {
              if (option.property === key && !log.changedOptions.find(x => x === option.name)) {
                log.changedOptions.push(option.name);
              }
            });
          })
        }
      }

      const result = [];
      this.logs.forEach(log => {
        if (log.changedOptions.length > 0) {
          const changedOptions = log.changedOptions.join(", ");
          result.push(`${Tier1.SuperAdminSettings}: ${log.name}: ${changedOptions}`);
        }
      });

      this.logs = null;
      this.initialCheckboxes = null;
      return result;
    },
  },
  watch: {
    'selectedFacility.isCarePlan'(newValue) {
      this.familyFeaturesChanged.isCarePlanChanged = true;
      this.selectedFacility.isEnabledCarePlan = newValue;
    },
    'selectedFacility.isCareSummary'(newValue) {
      this.familyFeaturesChanged.isCareSummaryChanged = true;
    },
    'selectedFacility.isDailyPlan'(newValue) {
      this.familyFeaturesChanged.isDailyPlanChanged = true;
    },
    'selectedFacility.isDailyCare'(newValue) {
      this.familyFeaturesChanged.isDailyCareChanged = true;
    },
    'selectedFacility.name'(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.isFacilityNameChanged = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application #user-management {
  .v-card {
    box-shadow: none !important;
  }
}

.facility-settings {
  h4 {
    margin-top: 3px;
    margin-bottom: 10px !important;
  }
  h5 {
    margin-top: 5px;
    margin-bottom: 10px !important;
  }

  ::v-deep .family-engagement-description {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
    line-height: 1.4;
  }
}

::v-deep.facility-settings ::v-deep.v-list-item__action {
  margin-right: 15px !important;
}
</style>
